import {
  EstadoLlamada,
  IDataPreventa,
  IPreagendamiento,
  MotivoRechazo,
  ObservacionesAgendamiento,
  Plan,
} from '.';
import { Flota, Sector, Zone } from './mantenimiento-operaciones';
import { IDataProspecto } from './prospecto';
import { Vendedor } from './ventas';

export interface AgendasPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: Agenda[];
}

export interface Agenda {
  id_agenda?: number;
  fecha: string;

  // // prospecto
  tipo_documento: string; // fk
  numero_contrato: string; // generated by api
  identificacion: string;
  fecha_nacimiento: string;
  edad: number;
  // fk
  nacionalidad: string;
  condicion_residencia: string;
  pais: string;
  provincia: string;
  ciudad: string;
  zona: number;
  sector: number;
  direccion: string;
  // parroquia: string;

  // contacto
  celular: string;
  telefono_fijo: string;
  persona_referencia: string;
  parentesco_referencia: string;
  celular_referencia: string;
  telefono_fijo_referencia: string;
  telefono_adicional: string;
  email: string;

  // // buro
  segmentacion: string;
  puntaje_empresa: string;

  // // detalles servicio internet
  tipo_servicio: string; // fk
  plan: number; // fk
  velocidad_internet: string;
  tipo_instalacion: string; // fk
  valor_instalacion: string; // keyfax
  valor_instalacion_sin_iva: string;
  valor_instalacion_total: string;

  // // detalles instalacion
  nap: string;
  nap_nombre: string;
  distancia_aproximada: string; // respecto snap
  detalle_instalacion: string;
  flota: number;
  fecha_hora_instalacion: string;

  url_contrato: string; // generated by api
  coordenadas: string;

  herramienta_utilizada: string;
  numero_pisos: number;
  numero_dispositivos: number;
  tipo_uso: string; // JSON
  tipo_vivienda: string;
  como_se_entero: string;
  valor_plan: string;
  bloquear_hasta?: string;

  estado_pil: number; // fk
  motivo: string; // motivo_rechazo pyl
  motivo_rechazo_orden?: string; // recoordinacion

  // recoordinacion OW
  fecha_hora_recordinacion?: string;

  ///* fk
  prospecto: string;
  preventa: string;
  user: number; // user logueado - quien crea la agenda
  cliente: number;
  cliente_nombre: string;
  estado_pil_info: {
    id_estado_pil: number;
    nombre: string;
    codigo: string;
    fecha_creacion: string;
    fecha_modificacion: string;
  };
  motivo_rechazo_data: MotivoRechazo;

  fecha_creacion: string; // createdAt
  flota_data: Flota;

  vendedor: number;
  vendedor_data: Vendedor;
  prospecto_data?: Omit<IDataProspecto, 'solictud_canje_data' | 'solictud_evento_data'>
  preventa_data: IDataPreventa; // equipos_adicionales
  plan_data: Plan;

  user_pyl_aprueba: number;
  user_pyl_rechaza: number;
  user_pyl_reagenda: number;
  user_pyl_recoordina: number; // aprueba recoordinacion
  user_activacion: number; // recoordina ot

  // // rubro instalacion (valor_instalacion)
  estado_pago: string; // para != entidades
  pasa_revision: boolean; // pasa a revision pyl
  descripcion_pago: string;
  foto_comprobante: string;

  //
  cliente_data: {
    nombre: string;
    forma_pago: string;
    valor_instalacion: string;
    celular: string;
  };
  zona_data?: Zone;
  sector_data?: Sector;

  numero_referencia: string;
  numero_comprobante: string;

  // requerido
  estado_llamada: string; // fk: code
  observacion_llamada: string;
  estado_llamada_data?: EstadoLlamada;
}

export type AgendaWithProspecto = Agenda & {
  cliente_data: IDataProspecto;
};

export interface IFiltrosGenerarExcelAgenda {
  numero_contrato?: string | null;
  identificacion?: string | null;
  estado_pil?: string | null;
  fecha_after?: string | null;
  fecha_before?: string | null;
  fecha_hora_instalacion_after?: string | null;
  fecha_hora_instalacion_before?: string | null;
}

export interface IDataEstadosPil {
  id_estado_pil: number;
  nombre: string;
  codigo: string;
}

//

export interface IFormPreagendamiento extends Partial<IPreagendamiento> {
  distancia?: string;
  distancia_polmax?: string;
  coordenadas: string;
  flota?: string;

  fecha_instalacion?: string;
  hora_instalacion?: string;
  detalle_instalacion?: string;
  prospecto?: string;
  preventa?: string;
  usos?: any;
  encuesta?: any;
  descripcion_pago?: string;


  //opcionales
  url_foto_comprobante?: string;
  numero_comprobante?: string;

  //auxilares
  horas?: string[];
  nap_nombre?: string | null;
  trabajo_estudio?: boolean;
  entretenimiento?: boolean;
  juegos?: boolean;
  redes_sociales?: boolean;
  streaming?: boolean;
  domotica?: boolean;

  como_se_entero: string;
  herramienta_utilizada: string;
  tipo_vivienda: string;
  numero_pisos: string;
  numero_dispositivos: string;

  estado_pago?: string;

}


export enum DescripcionPagoInstall {
  PAGADO = 'PAGADO',
  PENDIENTE = 'PENDIENTE',

  INSTALACION_GRATUITA = 'INSTALACION GRATUITA',
}

export enum EstadoPagoEnum {
  GRATUITO_DEBITO = 'GRATUITO DEBITO',
  GRATUITO_CREDITO = 'GRATUITO CREDITO',

  //VOUCHER_PENDIENTE = 'VAUCHER PENDIENTE',
  VOUCHER_PENDIENTE = 'PENDIENTE', //CAMBIO CONTROLADO POR EL BACKEND
  VOUCHER_CARGADO = 'VAUCHER CARGADO',
  VOUCHER_RECHAZADO = 'VOUCHER RECHAZADO',

  PAGADO_RUBRO = 'PAGADO RUBRO',
}

export type TipoUsoType = {
  trabajo_estudio: boolean;
  entretenimiento: boolean;
  juegos: boolean;
  redes_sociales: boolean;
  streaming: boolean;
  domotica: boolean;
};

export interface FormMotivoRechazoAgendaVenta {
  id_agendamiento: string
  id_preagendamiento: string
  motivo_rechazo: string
  razon_social?: string
  identificacion?: string
  observaciones?: ObservacionesAgendamiento
  observacion_cancelacion?: string
}
